import { BrowserCacheLocation, Configuration, EventType, PublicClientApplication } from '@azure/msal-browser';

import { BackendConfigJson, backendConfigJsonSchema } from './utils/BackendInfrastructure/backendConfigJsonSchema';
import { localhostDefaultConfig } from './utils/BackendInfrastructure/localhostDefaultConfig';

export const getBackendConfig = async (): Promise<BackendConfigJson> => {
  if (window.location.hostname === 'localhost') {
    return localhostDefaultConfig;
  }

  const config = await fetch('/backend-config.json');
  return backendConfigJsonSchema.parse(await config.json());
};

export class AzureApplication extends PublicClientApplication {
  public static async createFromBackendConfig(backendConfig: BackendConfigJson): Promise<AzureApplication> {
    const instance = new AzureApplication({
      auth: {
        clientId: backendConfig.AzureAdClientId,
        authority: `https://login.microsoftonline.com/${backendConfig.AzureAdTenantId}`,
        redirectUri: backendConfig.AzureAdRedirectUri,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
      },
    });

    await instance.initialize();
    await instance.handleRedirectPromise();
    return instance;
  }

  public constructor(config: Configuration) {
    super(config);

    this.addEventCallback((event) => {
      if (
        event.eventType === EventType.INITIALIZE_END ||
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
      ) {
        const accounts = this.getAllAccounts();
        if (accounts.length > 0) {
          this.setActiveAccount(accounts[0]);
        }
      }
    });
  }
}
